/**
 * Glifo di stato v4 (N11, `Centro Ticket v4.dc.html` L299 e L808-L815):
 * cerchio 11 px vuoto / mezzo / pieno / ambra / grigio / chip. Sostituisce il
 * badge verde dello stato, che rendeva indistinguibili i tre stati «verdi».
 *
 * Il glifo ha sempre un nome accessibile (`Stato: …`): il colore e la forma non
 * bastano a chi non li vede. Con `withLabel` l'etichetta e anche scritta accanto
 * (nascosta ai lettori di schermo, che la ricevono gia dal glifo).
 * Con `decorative` e il contrario: l'etichetta e gia scritta accanto dal
 * chiamante, quindi il glifo e nascosto ai lettori (niente nome doppio).
 */
import React from 'react';
import { statusGlyph } from '../v3/visual';

export interface StatusGlyphProps {
  status: string;
  withLabel?: boolean;
  /** Diametro: 11 in tabella/scheda, 10 nelle card (L261). */
  size?: 10 | 11;
  /** L'etichetta dello stato e gia scritta accanto: glifo `aria-hidden`. */
  decorative?: boolean;
}

const StatusGlyph: React.FC<StatusGlyphProps> = ({ status, withLabel = false, size = 11, decorative = false }) => {
  const g = statusGlyph(status);
  const a11y = decorative
    ? { 'aria-hidden': true as const }
    : { role: 'img' as const, 'aria-label': `Stato: ${g.label}` };
  const glyph = (
    <span
      className={`s4-sg s4-sg--${g.kind}${size === 10 ? ' s4-sg--sm' : ''}`}
      {...a11y}
      data-kind={g.kind}
    />
  );
  if (!withLabel) return glyph;
  return (
    <span className="s4-sgl">
      {glyph}
      <span className="s4-sgl__txt" aria-hidden="true">
        {g.label}
      </span>
    </span>
  );
};

export default StatusGlyph;
